<style scoped>
  .input--filled .input__label-content {
    top: 5px;
    color: #1a1a1b;
    opacity: 0.4;
    font-size: 12px;
  }

  .autosuggest-container {
    --theme-bg: white;
    --theme-color: black;
    --theme-item_bg_highlighted: #eeeeee;
    --theme-item_color_highlighted: black;
  }

  .autosuggest-container >>> .autosuggest__results-container {
    position: relative;
    width: 100%;
    background-color: var(--theme-bg);
  }

  .autosuggest-container >>> .autosuggest__results {
    background-color: var(--theme-bg);
    font-weight: 300;
    position: absolute;
    z-index: 10000001;
    width: 100%;
    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.15);
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: 0;
    max-height: 400px;
    margin: 50px 0 0;
  }

  .autosuggest-container >>> .autosuggest__results ul {
    list-style: none;
    padding-left: 0;
    margin: 0;
    background-color: var(--theme-bg);
  }

  .autosuggest-container >>> .autosuggest__results .autosuggest__results-item {
    cursor: pointer;
    background-color: var(--theme-bg);
    padding: 10px;
  }

  .autosuggest-container
  >>> #autosuggest
  ul:first-child
  > .autosuggest__results-before {
    border-top: none;
  }

  .autosuggest-container >>> .autosuggest__results .autosuggest__results-before {
    color: var(--theme-color);
    opacity: 0.5;
    font-size: 11px;
    margin-left: 0;
    padding: 15px 13px 5px;
    border-top: 1px solid #d3d3d3;
  }

  .autosuggest-container
  >>> .autosuggest__results
  .autosuggest__results-item.autosuggest__results-item--highlighted,
  .autosuggest__results .autosuggest__results-item:active,
  .autosuggest__results .autosuggest__results-item:focus,
  .autosuggest__results .autosuggest__results-item:hover {
    background-color: var(--theme-item_bg_highlighted);
    color: var(--theme-item_color_highlighted);
  }

  .change_address .dol_dop_text:hover {
    cursor: pointer;
    color: #5c5c5c;
  }

  .change_address .dol_dop_text:hover img {
    filter: brightness(0.6);
  }

  .autosuggest-container {
    display: flex;
    justify-content: center;
  }

  .autosuggest-container ul {
    width: 100%;
    color: rgba(30, 39, 46, 1);
    list-style: none;
    margin: 0;
    padding: 0.5rem 0 0.5rem 0;
  }

  .autosuggest-container li {
    margin: 0 0 0 0;
    border-radius: 5px;
    padding: 0.75rem 0 0.75rem 0.75rem;
    display: flex;
    align-items: center;
  }

  .autosuggest-container li:hover {
    cursor: pointer;
  }

  #autosuggest {
    width: 100%;
    display: block;
  }

  .autosuggest__results-item--highlighted {
    background-color: rgba(51, 217, 178, 0.2);
  }

  .btn_trans {
    background-color: #ebf5ff;
    color: #0084ff;
    box-shadow: none;
  }
</style>

<template>
  <div>
    <div
      class="do_title"
      style="margin-bottom: 18px; display: flex; padding-left: 10px"
    >
      <span
        class="bh_back pointer"
        @click="back"
        v-if="canGoBack"
        style="padding-right: 20px"
      >
        <img
          :src="require('@/assets/img/facebook/back_str.svg')"
          alt="back"
        />
      </span>
      <span>{{ text('website_ask_address') }}</span>
    </div>
    <div
      class="delivery_oplata substrate"
      style="margin-bottom: 15px; margin-top: 0"
    >
      <div
        class="delivery_oplata_list"
        style="margin-top: 0"
      >
        <a
          @click="enableInputAddress()"
          class="fbb_btn"
          style="margin-top: 20px; margin-bottom: 20px; cursor: pointer"
          v-if="!inputAddressEnabled && !inputGeoAddress"
        >
          {{ text('website_input_address') }}
        </a>

        <a
          @click="sendPosition()"
          class="fbb_btn"
          style="margin-top: 20px; margin-bottom: 20px; cursor: pointer"
          :class="{
            btn_trans:
              !$store.getters.loading[GET_GEO_ADDRESS] &&
              (this.inputAddressEnabled || this.geolocationAddress),
          }"
        >
          {{ text('website_send_geo') }}
          <svg
            class="svg_anim"
            style="
              position: absolute;
              width: 20px;
              top: 16px;
              margin-left: 12px;
            "
            v-if="$store.getters.loading[GET_GEO_ADDRESS]"
            version="1.1"
            viewBox="0 0 130.2 130.2"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              class="path circle"
              cx="65.1"
              cy="65.1"
              fill="none"
              r="57.1"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="14"
            />
          </svg>
          <svg
            class="svg_anim"
            style="
              position: absolute;
              width: 20px;
              top: 16px;
              margin-left: 12px;
            "
            v-if="error.sendPosition"
            version="1.1"
            viewBox="0 0 130.2 130.2"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              class="path line"
              fill="none"
              stroke="#fff"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="12"
              style="stroke-dasharray: 100"
              x1="34.4"
              x2="95.8"
              y1="37.9"
              y2="92.3"
            />
            <line
              class="path line"
              fill="none"
              stroke="#fff"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="12"
              style="stroke-dasharray: 100"
              x1="95.8"
              x2="34.4"
              y1="38"
              y2="92.2"
            />
          </svg>
        </a>
      </div>
    </div>

    <transition name="list">
      <div
        class="delivery_oplata substrate"
        style="margin-bottom: 15px; margin-top: 0px"
        v-if="inputAddressEnabled"
      >
        <div
          class="delivery_oplata_list"
          style="margin-top: 0px"
        >
          <div>
            <span class="input input_style input--filled">
              <form v-on:submit.prevent="sendAddress()">
                <div class="autosuggest-container">
                  <vue-autosuggest
                    v-model="inputAddress"
                    :suggestions="[{ data: $store.getters.addressSuggestions }]"
                    @selected="onSelectSuggestion"
                    :input-props="{
                      disabled: $store.getters.loading[GET_INPUT_GEO_ADDRESS],
                      placeholder: placeholder,
                      class: 'input__field input__field--ruri',
                      id: 'inputAddress',
                    }"
                  >
                    <div
                      slot-scope="{ suggestion }"
                      style="display: flex; align-items: center"
                    >
                      <div style="{ display: 'flex', color: 'navyblue'}">
                        {{ suggestion.item }}
                      </div>
                    </div>
                  </vue-autosuggest>
                </div>
                <div class="input__label">
                  <span class="input__label-content">{{
                    text('website_input_address_label')
                  }}</span>
                </div>
              </form>
            </span>
          </div>

          <a
            @click="sendAddress()"
            class="fbb_btn"
            style="margin-top: 20px; margin-bottom: 20px; cursor: pointer"
          >
            {{ text('website_send_address') }}
            <svg
              class="svg_anim"
              style="
                position: absolute;
                width: 20px;
                top: 16px;
                margin-left: 12px;
              "
              v-if="$store.getters.loading[GET_INPUT_GEO_ADDRESS]"
              version="1.1"
              viewBox="0 0 130.2 130.2"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                class="path circle"
                cx="65.1"
                cy="65.1"
                fill="none"
                r="57.1"
                stroke="#fff"
                stroke-miterlimit="10"
                stroke-width="14"
              />
            </svg>
            <svg
              class="svg_anim"
              style="
                position: absolute;
                width: 20px;
                top: 16px;
                margin-left: 12px;
              "
              v-if="error.sendAddress"
              version="1.1"
              viewBox="0 0 130.2 130.2"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                class="path line"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="12"
                style="stroke-dasharray: 100"
                x1="34.4"
                x2="95.8"
                y1="37.9"
                y2="92.3"
              />
              <line
                class="path line"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="12"
                style="stroke-dasharray: 100"
                x1="95.8"
                x2="34.4"
                y1="38"
                y2="92.2"
              />
            </svg>
          </a>
        </div>
      </div>
    </transition>

    <transition name="list">
      <div
        class="delivery_oplata substrate"
        style="margin-bottom: 80px; margin-top: 0px"
        v-show="availableAddresses.length"
      >
        <div class="do_title">
          {{ text('screen_form_delivery_address') }}
        </div>
        <div class="delivery_oplata_list">
          <transition-group name="list">
            <label
              :key="
                availableAddress.lat +
                ', ' +
                availableAddress.lng +
                ' ' +
                availableAddress.address
              "
              class="dol_block"
              v-for="availableAddress in availableAddresses"
            >
              <input
                :value="availableAddress"
                name="type"
                type="radio"
                v-model="address"
              />
              <div class="dol_content">
                <div class="dol_inner">
                  <div class="dol_name">
                    {{ availableAddress.address }}
                    <template v-if="availableAddress.geo">🛰</template>
                    <template v-if="availableAddress.inputGeo">📍</template>
                  </div>
                  <div
                    class="dol_dop"
                    v-if="availableAddress.text"
                  >
                    <div
                      class="dol_dop_text"
                      v-html="
                        sanitize(availableAddress.text.replace(/\n/g, '<br>'))
                      "
                    ></div>
                  </div>
                  <div
                    class="dol_dop change_address"
                    v-if="availableAddress.inputGeo === true"
                    style="
                      text-align: center;
                      margin-top: 6px;
                      visibility: visible;
                      opacity: 1;
                      height: auto;
                    "
                  >
                    <div class="dol_dop_text">
                      <span
                        style="margin: 10px; padding: 10px"
                        @click="changeAddress()"
                      >{{ text('website_another_address')
                        }}<img
                          :src="require('@/assets/img/facebook/x.svg')"
                          alt="x"
                          style="margin-left: 3px; vertical-align: middle"
                        /></span>
                    </div>
                  </div>
                </div>
              </div>
            </label>
          </transition-group>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {
    GUARD_INIT,
    GET_ADDRESSES,
    GET_GEO_ADDRESS,
    GET_INPUT_GEO_ADDRESS,
    SET_PROFILE_ADDRESS,
    ENABLE_OVERLAY,
    DISABLE_OVERLAY,
    GUARD_NEXT,
    GET_ADDRESS_SUGGESTIONS,
    GUARD_BACK
  } from '@/store/actions.type'

  import {
    SET_WEBVIEW_GUARD,
    SET_GUARD_PASS,
    SET_GEO_ADDRESS,
    SET_INPUT_GEO_ADDRESS,
    SET_GUARD_OUTLET_ID,
    SET_GUARD_ADDRESS,
    SET_ADDRESS_SUGGESTIONS,
    SET_GUARD_MODE,
    SET_DELIVERY_TO_CITY
  } from '@/store/mutations.type'

  let debounce = require('lodash.debounce')

  import {VueAutosuggest} from 'vue-autosuggest'
  import {mapGetters} from 'vuex'

  export default {
    name: 'Address',

    data() {
      return {
        address: null,

        inputAddress: null,
        inputAddressEnabled: false,

        suggestedAddress: null,

        error: {
          sendPosition: false,
          sendAddress: false
        },

        GET_GEO_ADDRESS,
        GET_INPUT_GEO_ADDRESS,
        SET_PROFILE_ADDRESS
      }
    },

    components: {
      VueAutosuggest
    },

    methods: {
      async next() {
        if (this.$store.getters.loading[SET_PROFILE_ADDRESS]) {
          return
        }

        let outlet_id = null
        let identifier = null
        for (let i in this.guardOutlets) {
          if (
            this.guardOutlets[i].internal_id === this.address.internal_id &&
            this.guardOutlets[i].type_id === this.guardTypeID &&
            this.guardOutlets[i].city_id === this.guardCityID
          ) {
            identifier = this.guardOutlets[i].identifier
            outlet_id = this.guardOutlets[i].outlet_id
            break
          }
        }
        await this.$store.commit(SET_GUARD_PASS, identifier)
        await this.$store.commit(SET_GUARD_OUTLET_ID, outlet_id)
        await this.$store.commit(SET_GUARD_ADDRESS, this.address)

        let setProfileResult = await this.$store.dispatch(SET_PROFILE_ADDRESS, {
          address: this.address
        })
        if (setProfileResult.status !== 200) {
          return
        }

        await this.$store.dispatch(GUARD_NEXT)
      },

      async back() {
        if (this.$store.getters.guardCssDirection === 'rtl') {
          this.$emit('back', 'right')
        }
        await this.$store.dispatch(GUARD_BACK)
      },

      onSelectSuggestion(item) {
        if (item) {
          this.suggestedAddress = item.item
          this.inputAddress = item.item

          setTimeout(function () {
            let element = document
              .getElementById('autosuggest')
              .querySelector('input')
            element.focus()
            element.selectionStart = element.selectionEnd = element.value.length
          }, 100)
        }
      },

      async sendPosition() {
        if (this.$store.getters.loading[GET_GEO_ADDRESS]) {
          return
        }
        this.$store.dispatch(GET_GEO_ADDRESS)
      },

      async sendAddress() {
        if (
          !this.inputAddress ||
          this.$store.getters.loading[GET_INPUT_GEO_ADDRESS]
        ) {
          return
        }
        this.$store.dispatch(GET_INPUT_GEO_ADDRESS, {
          latitude: null,
          longitude: null,
          address: this.inputAddress,
          suggested:
            this.suggestedAddress && this.suggestedAddress === this.inputAddress
        })
      },

      changeAddress() {
        this.$store.commit(SET_INPUT_GEO_ADDRESS, null)
        this.enableInputAddress()
      },

      setSendPositionError() {
        this.error.sendPosition = true
        setTimeout(() => {
          this.error.sendPosition = false
        }, 2000)
      },

      setSendAddressError() {
        this.error.sendAddress = true
        setTimeout(() => {
          this.error.sendAddress = false
        }, 2000)
      },

      enableInputAddress() {
        this.inputAddressEnabled = true
        setTimeout(function () {
          document.getElementById('inputAddress').focus()
        }, 100)
      },

      suggest() {
        this.$store.dispatch(GET_ADDRESS_SUGGESTIONS, {
          address_query: this.inputAddress
        })
      }
    },

    computed: {
      canGoBack() {
        return (
          this.$store.getters.guardModeInitial ===
          this.$store.getters.guardModes.GUARD_MODE_CITY ||
          this.$store.getters.guardModeInitial ===
          this.$store.getters.guardModes.GUARD_MODE_ORDER_TYPE_AND_OUTLETS
        )
      },

      placeholder() {
        if (!this.address) {
          return this.text('website_input_address_placeholder')
        }
      },

      availableAddresses() {
        let arr = []
        if (this.addresses) {
          arr = JSON.parse(JSON.stringify(this.addresses))
        }
        if (
          this.geolocationAddress &&
          this.geolocationAddress !== this.GEOLOCATION_ADDRESS_ERROR
        ) {
          arr.push(this.geolocationAddress)
        }
        if (
          this.inputGeoAddress &&
          this.inputGeoAddress !== this.GEOLOCATION_ADDRESS_ERROR
        ) {
          arr.push(this.inputGeoAddress)
        }
        return arr
      },

      ...mapGetters([
        'guardOutlets',
        'guardTypes',
        'guardCityID',
        'guardTypeID',
        'addresses',
        'geolocationAddress',
        'inputGeoAddress',
        'GEOLOCATION_ADDRESS_ERROR'
      ])
    },

    mounted() {
      this.$store.dispatch(GET_ADDRESSES)
    },

    watch: {
      inputAddress: debounce(function (inputAddress) {
        if (
          !this.suggestedAddress ||
          this.suggestedAddress !== this.inputAddress
        ) {
          if (inputAddress.length >= 3) {
            this.suggest()
          } else {
            this.$store.commit(SET_ADDRESS_SUGGESTIONS, [])
          }
        }
      }, 300),

      geolocationAddress(geolocationAddress) {
        if (geolocationAddress === this.GEOLOCATION_ADDRESS_ERROR) {
          this.setSendPositionError()
          this.$store.commit(SET_GEO_ADDRESS, null)
        } else {
          if (geolocationAddress) {
            if (this.address.geo === true) {
              this.address = null
            }
            this.address = geolocationAddress
          }
        }
      },

      inputGeoAddress(inputGeoAddress) {
        if (inputGeoAddress === this.GEOLOCATION_ADDRESS_ERROR) {
          this.setSendAddressError()
          this.$store.commit(SET_INPUT_GEO_ADDRESS, null)
        } else {
          if (inputGeoAddress) {
            this.inputAddressEnabled = false
            this.address = inputGeoAddress
          } else {
            if (this.address && this.address.inputGeo === true) {
              this.address = null
            }
            this.inputAddressEnabled = true
          }
        }
      },

      address(address) {
        this.$store.commit(SET_DELIVERY_TO_CITY, address.city)
        this.$emit('update:addressData', address)
      }
    },

    updated() {
      this.$emit('update:addressData', this.address)
    }
  }
</script>
